/**
 * BDA-5489 — kebab-case IDs for Stiftung-Gesundheit Betriebsarten.
 *
 * Replaces the legacy English `AysMedicalInstitutionType` codes
 * (`MEDICAL_CARE_CENTER`, `PRACTICE`, …). The BE no longer accepts the
 * legacy values — sending one collapses to UNKNOWN at the predicate level.
 *
 * Keeps the legacy module shape (type union + values constant +
 * display-name Record); only the type prefix and value set changed.
 */
export type BdMedicalInstitutionType =
  | 'einzelpraxis'
  | 'gemeinschaftspraxis'
  | 'praxisgemeinschaft'
  | 'nebenbetriebsstaette'
  | 'ueberoertliche-gemeinschaftspraxis';

export const BD_MEDICAL_INSTITUTION_TYPES: BdMedicalInstitutionType[] = [
  'einzelpraxis',
  'gemeinschaftspraxis',
  'praxisgemeinschaft',
  'nebenbetriebsstaette',
  'ueberoertliche-gemeinschaftspraxis',
];

export const BD_MEDICAL_INSTITUTION_TYPE_DISPLAY_NAME: Record<BdMedicalInstitutionType, string> = {
  einzelpraxis: 'Einzelpraxis',
  gemeinschaftspraxis: 'Gemeinschaftspraxis',
  praxisgemeinschaft: 'Praxisgemeinschaft',
  nebenbetriebsstaette: 'Nebenbetriebsstätte',
  'ueberoertliche-gemeinschaftspraxis': 'überörtliche Gemeinschaftspraxis',
};
